<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement()">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" @click="Toggle">
                      <v-icon class="mr-2">mdi-file</v-icon>
                      {{ route==0 ? '&nbsp;&nbsp;Tax&nbsp;&nbsp;' : 'Order' }}
                    </v-btn>
                    <v-btn color="success" class="button-shadow mb-2 mr-0 mr-sm-2" @click="Done">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <div :style="style" id="print-page">
                  <iframe :src="url" frameborder="0" width="100%" height="1110" style="align-content: center;"></iframe>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    export default {
        name: 'PrintPage',
        data(){
          return {
            url: null,
            route: null,
            window_width: window.innerWidth,
            initvalue: {},
            style: '',
          };
        },
        computed: {

        },
        methods: {
          Done() {
            if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
            else this.$router.replace({ name: 'Dashboard' });
          },
          Toggle() {
            this.route = !this.route;
            if(this.route==1) this.url = `https://tradexc.com/#/print/salesorder/tax/${this.initvalue._id}-${this.initvalue.key}`;
            else this.url = `https://tradexc.com/#/print/salesorder/order/${this.initvalue._id}-${this.initvalue.key}`;
          },
          onResize() {
            this.window_width = window.innerWidth;
            this.scalewindow();
          },
          scalewindow(){
            if(this.window_width<900)this.style = `width: ${this.window_width-180}; height: auto; overflow-x: hidden; zoom: ${this.window_width/900}; text-align: center; background-color: white;`;
            else this.style = "width: 100%; height: auto; overflow-x: hidden; zoom: 1.0; background-color: white;"
            console.log(this.style)
          },
          PrintElement() {
            let options = 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0';
            let mywindow = window.open(this.url, '_blank', options);
            mywindow.document.close();
            mywindow.focus();
            setTimeout(function() {
              mywindow.print();
                }, 3000);
            return;
          },
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'SalesOrderList' });
          this.route = 0;
          this.url = `https://tradexc.com/#/print/salesorder/order/${this.initvalue._id}-${this.initvalue.key}`;
        },
        mounted(){
          this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
          })
        },
        beforeDestroy() { 
          window.removeEventListener('resize', this.onResize); 
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
